
//
// Live Price
//
// Update the value on the page when the controller recalculates it
//

module.exports = function LivePriceWidget ($host, config, $$) {


  // DOM

  var $output = $$('[data-price]');


  // Functions

  function setValue (value) {
    $output.text('$' + value);
  }


  // Interface

  return {
    setValue: setValue,
  }

}

